import GaugeComponent from 'react-gauge-component';
import { useTheme } from '@/hooks/useTheme';

interface AnimatedGaugeChartProps {
  max?: number;
  value: number;
  min?: number;
  gaugePrimaryColor: string;
  gaugeSecondaryColor: string;
  className?: string;
}

export function AnimatedGaugeChart({
  max = 100,
  min = 0,
  value = 0,
  gaugePrimaryColor,
  gaugeSecondaryColor,
  className,
}: AnimatedGaugeChartProps) {
  const { theme } = useTheme();
  const normalizedValue = Math.max(min, Math.min(max, value));
  const currentPercent = ((normalizedValue - min) / (max - min)) * 100;

  return (
    <div className={className} style={{ position: 'relative', width: '100%', height: '100%', margin: 0, padding: 0 }}>
      <style>{`
        div[class*="gauge"] text,
        svg text {
          display: none !important;
        }
        div[class*="gauge"] line[stroke],
        svg line[stroke] {
          display: none !important;
        }
        div[class*="gauge"] .tick-line,
        svg .tick-line {
          display: none !important;
        }
        div[class*="gauge"] {
          width: 100% !important;
          height: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
          display: flex !important;
          align-items: flex-start !important;
          justify-content: flex-start !important;
          overflow: visible !important;
        }
        div[class*="gauge"] svg {
          width: 100% !important;
          height: 100% !important;
          display: block !important;
          margin: 0 !important;
          padding: 0 !important;
          position: relative !important;
          left: 0 !important;
          top: 0 !important;
          overflow: visible !important;
          margin-left: 0 !important;
        }
        div[class*="gauge"] svg g {
          transform-origin: left center !important;
        }
        div[class*="gauge"] svg > g:first-child {
          transform: translateX(0) !important;
        }
        div[class*="gauge"] > div {
          margin: 0 !important;
          padding: 0 !important;
          width: 100% !important;
          height: 100% !important;
          display: flex !important;
          align-items: flex-start !important;
          justify-content: flex-start !important;
        }
        div[class*="gauge"] svg {
          vertical-align: top !important;
        }
      `}</style>
      <GaugeComponent
        value={normalizedValue}
        type="radial"
        labels={{
          valueLabel: {
            hide: true
          },
          tickLabels: {
            type: "inner",
            ticks: []
          }
        }}
        arc={{
          colorArray: [gaugePrimaryColor, gaugeSecondaryColor],
          subArcs: [
            { 
              limit: currentPercent,
              color: gaugePrimaryColor,
            },
            { 
              limit: max,
              color: gaugeSecondaryColor,
            }
          ],
          padding: 0.01,
          width: 0.25,
          gradient: false
        }}
        pointer={{
          elastic: true,
          animationDelay: 0,
          color: theme === 'dark' ? '#11223d' : '#1F2937',
          width: 7,
          length: 0.6
        }}
        minValue={min}
        maxValue={max}
        style={{ height: '100%', width: '100%', minHeight: '100%', minWidth: '100%' }}
      />
    </div>
  );
}
